module.exports = __webpack_public_path__ + "static/order-hero-background-8bbb694578c82f6eae6a3e8d5b3f2387.jpg";